var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio",on:{"click":function($event){return _vm.$emit('click')}}},[_c('input',{staticClass:"radio-input",attrs:{"type":"radio","name":_vm.name},domProps:{"checked":_vm.checked}}),_c('span',{staticClass:"radio-checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }